import React from 'react';
import { getStatusIcon } from '../../utils/statusIcons';

const StatusLegend = () => {
  const statuses = [
    { key: 'unexplored', label: 'Unexplored' },
    { key: 'in_progress', label: 'In Progress' },
    { key: 'needs_improvement', label: 'Needs Improvement' },
    { key: 'mastered', label: 'Mastered' },
  ];

  return (
    <div className="flex flex-wrap items-center gap-4 md:gap-6 p-3 bg-slate-50 dark:bg-slate-900/50 rounded-xl border border-slate-200 dark:border-slate-800 text-sm">
      <span className="font-bold text-slate-500 dark:text-slate-400 uppercase text-xs tracking-wider mr-2">Status Legend:</span>
      {statuses.map(({ key, label }) => {
        const { icon, color } = getStatusIcon(key);
        return (
          <div key={key} className="flex items-center gap-2">
            <span className={`material-symbols-outlined text-[18px] ${color}`}>
              {icon}
            </span>
            <span className="text-slate-600 dark:text-slate-300 font-medium">{label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default StatusLegend;
